import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import api from "@/lib/api";
import { fileUrl } from "@/lib/api";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, aspect = "aspect-video", label = "Upload an image", testid = "image-upload" }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (file) => {
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) { toast.error("Image must be under 8MB"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch {
      toast.error("Upload failed. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`relative ${aspect} rounded-2xl border-2 border-dashed border-[#071126]/15 bg-[#FFFDF8] overflow-hidden`} data-testid={testid}>
      {value ? (
        <>
          <img src={fileUrl(value)} alt="" className="h-full w-full object-cover" />
          <button type="button" onClick={() => onChange("")} className="absolute top-2 right-2 h-8 w-8 grid place-items-center rounded-full bg-white/90 shadow hover:bg-white" data-testid={`${testid}-remove`}>
            <X className="h-4 w-4 text-[#071126]" />
          </button>
        </>
      ) : (
        <button type="button" onClick={() => inputRef.current?.click()} className="h-full w-full flex flex-col items-center justify-center text-[#55708F] hover:text-[#FF6B00] transition-colors" data-testid={`${testid}-trigger`}>
          {busy ? <Loader2 className="h-6 w-6 animate-spin" /> : <ImagePlus className="h-6 w-6" />}
          <span className="text-sm mt-2 font-medium">{busy ? "Uploading…" : label}</span>
          <span className="text-xs mt-0.5 opacity-70">PNG or JPG, up to 8MB</span>
        </button>
      )}
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={(e) => handle(e.target.files?.[0])} />
    </div>
  );
}
